import React from 'react';
import styled from 'styled-components';

interface Props {
	email: string;
	onRemove: () => void;
	invalid?: boolean;
}

const Chip = styled.span<{$invalid: boolean}>`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	border-radius: ${p => p.theme.ticketing.radius.full};
	padding: 2px 8px;
	font: ${p => p.theme.ticketing.font.body3};
	border: 1px solid ${p => (p.$invalid ? '#fca5a5' : '#e2e8f0')};
	background: ${p => (p.$invalid ? '#fef2f2' : '#f1f5f9')};
	color: ${p => (p.$invalid ? '#b91c1c' : '#334155')};
`;
const RemoveButton = styled.button`
	margin-left: 2px;
	display: inline-flex;
	height: 16px;
	width: 16px;
	align-items: center;
	justify-content: center;
	border: 0;
	border-radius: ${p => p.theme.ticketing.radius.full};
	background: transparent;
	color: currentColor;
	cursor: pointer;
	&:hover {
		background: #e2e8f0;
	}
`;

export function RecipientChip({email, onRemove, invalid = false}: Props) {
	return (
		<Chip $invalid={invalid}>
			{email}
			<RemoveButton type="button" aria-label={`Remove ${email}`} onClick={onRemove}>
				&times;
			</RemoveButton>
		</Chip>
	);
}
